import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		title: {
			'& h2': {
				fontWeight: 'bold',
			},
		},
		buttonsContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-end',
			padding: '0px 10px',
		},
		logInButton: {
			color: '#ffffff',
			backgroundColor: theme.palette.primary.main,
			'&:hover': {
				backgroundColor: theme.palette.primary.light,
			},
		},
	})
